import * as React from 'react'
import {
  FaIcon,
  faChevronRight,
  faChevronLeft,
  faChevronsLeftSolid,
  faChevronsRightSolid,
  faObjectGroupSolid,
} from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import Tooltip from '@/modules/drivers/shared/ToolTip'

const DailyNavigation = ({
  currentDate,
  goToDate,
  onShiftHour,
  rangeMode,
  onToggleRangeMode,
}: {
  currentDate: string
  goToDate: (days: number) => void
  onShiftHour?: (hours: number) => void
  rangeMode?: boolean
  onToggleRangeMode?: () => void
}) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-bg-white tw-px-5 tw-py-3">
      <div className="tw-flex tw-items-center tw-gap-1">
        <Tooltip text={t('monthlyActivity.oneWeekBack')} asChild>
          <div
            className="tw-flex tw-items-center tw-relative tw-justify-center tw-h-6 tw-w-6 tw-cursor-pointer tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
            onClick={() => goToDate(-7)}
          >
            <FaIcon icon={faChevronLeft} className="tw-h-[10px] tw-absolute -tw-right-[2px]" />
            <FaIcon icon={faChevronsLeftSolid} className="tw-h-[10px] tw-absolute -tw-left-[2px]" />
          </div>
        </Tooltip>
        <Tooltip text={t('monthlyActivity.oneDayBack')} asChild>
          <div
            className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
            onClick={() => goToDate(-1)}
          >
            <FaIcon icon={faChevronsLeftSolid} className="tw-h-[10px]" />
          </div>
        </Tooltip>
        <Tooltip text={t('monthlyActivity.oneHourBack')} asChild>
          <div
            className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
            onClick={() => onShiftHour?.(-1)}
          >
            <FaIcon icon={faChevronLeft} className="tw-h-[10px]" />
          </div>
        </Tooltip>
        <p className="tw-px-2 tw-text-base tw-font-semibold tw-text-content-base">
          {currentDate}
        </p>
        <Tooltip text={t('monthlyActivity.oneHourAhead')} asChild>
          <div
            className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
            onClick={() => onShiftHour?.(1)}
          >
            <FaIcon icon={faChevronRight} className="tw-h-[10px]" />
          </div>
        </Tooltip>
        <Tooltip text={t('monthlyActivity.oneDayAhead')} asChild>
          <div
            className="tw-grid tw-h-6 tw-w-6 tw-cursor-pointer tw-place-items-center tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
            onClick={() => goToDate(1)}
          >
            <FaIcon icon={faChevronsRightSolid} className="tw-h-[10px]" />
          </div>
        </Tooltip>
        <Tooltip text={t('monthlyActivity.oneWeekAhead')} asChild>
          <div
            className="tw-flex tw-items-center tw-justify-center tw-h-6 tw-w-6 tw-relative tw-cursor-pointer tw-rounded-full tw-border tw-border-base-300 tw-bg-white"
            onClick={() => goToDate(7)}
          >
            <FaIcon icon={faChevronsRightSolid} className="tw-h-[10px] tw-absolute -tw-left-[1px]" />
            <FaIcon icon={faChevronRight} className="tw-h-[10px] tw-absolute -tw-right-[2px]" />
          </div>
        </Tooltip>
      </div>
      {onToggleRangeMode && (
        <div className="tw-flex tw-items-center tw-gap-2">
          <button
            onClick={onToggleRangeMode}
            title={`${t('driverModule.range-selection')} (Ctrl+Shift)`}
            className={`tw-flex tw-h-7 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded tw-border tw-px-3 tw-text-xs tw-font-semibold tw-transition-colors ${
              rangeMode
                ? 'tw-border-primary tw-bg-primary tw-text-white'
                : 'tw-border-base-300 tw-bg-white tw-text-content-base hover:tw-bg-base-100'
            }`}
          >
            <FaIcon icon={faObjectGroupSolid} className="tw-h-[12px]" />
            <span>{t('driverModule.range-selection')}</span>
          </button>
        </div>
      )}
    </div>
  )
}

export default DailyNavigation
